import { createContext, useContext, useEffect, useState } from 'react';

const ControlThemeContext = createContext({
  theme: 'dark',
  setTheme: () => {},
  toggleTheme: () => {},
  isDark: true
});

export function ControlThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    // Check localStorage for control portal theme preference
    const stored = localStorage.getItem('control-theme');
    return stored || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('control-theme', theme);
     
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const isDark = theme === 'dark';

  return (
    <ControlThemeContext.Provider value={{ theme, setTheme, toggleTheme, isDark }}>
      {children}
    </ControlThemeContext.Provider>
  );
}

export const useControlTheme = () => {
  const context = useContext(ControlThemeContext);
  if (!context) {
    throw new Error('useControlTheme must be used within ControlThemeProvider');
  }
  return context;
};
